// extracted by mini-css-extract-plugin
export default {"cls1":"ResearchInterestDirectorySearch-cls1_y_a","cls2":"ResearchInterestDirectorySearch-cls2__be ResearchInterestDirectorySearch-cls1_y_a"};